import enLang from 'antd/es/locale/en_US';
import zhLang from 'antd/es/locale/zh_CN';
import frLang from 'antd/es/locale/fr_FR';
import jaLang from 'antd/es/locale/ja_JP';
import deLang from 'antd/es/locale/de_DE';
import ruLang from 'antd/es/locale/ru_RU';
import esLang from 'antd/es/locale/es_ES';
import itLang from 'antd/es/locale/it_IT';

const AppLocale = {
  en: enLang,
  zh: zhLang,
  fr: frLang,
  ja: jaLang,
  de: deLang,
  ru: ruLang,
  es: esLang,
  it: itLang,
};

export default AppLocale;
